<template>
  <div>
    <div class="row">
      <div v-if="flex !== undefined">
        <div v-if="!editable" class="col-md-12">
          <fg-input type="text"
                    label="Tecnología"
                    :disabled="!editable"
                    v-model="flex.tecnology">
          </fg-input>
        </div>
        <div v-if="editable" class="col-md-12">
          <div class="form-group">
            <drop-down :title="ddTitleTec">
              <a slot="title" class="dropdown-togGLe" data-togGLe="dropdown">
                <span>{{ddTitleTec}}</span>
                <i class="material-icons">expand_more</i>
              </a>
              <li><a @click="putTec('GPS')" >GPS</a></li>
            </drop-down>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
          <fg-input-validate
                      type="text"
                      validations="required|regex:^([0-9A-Za-z]+)$"
                      name="numero de serie"
                      label="Número de Serie"
                      delay="0"
                      :disabled="!editable"
                      @input-changed="input_changed"
                      :value="gps.serial_number"
                      v-model="gps.serial_number">
          </fg-input-validate>
      </div>
      <div class="col-md-6">
          <fg-input-validate
                      type="text"
                      validations="required|regex:^([0-9A-Za-z]+)$"
                      name="template"
                      label="Template"
                      delay="0"
                      :disabled="!editable"
                      @input-changed="input_changed"
                      :value="gps.template"
                      v-model="gps.template">
          </fg-input-validate>
      </div>
    </div>

    <div class="row">
      <div v-if="!editable" class="col-md-6">
        <fg-input type="text"
                  label="Marca"
                  :disabled="!editable"
                  v-model="gps.make">
        </fg-input>
      </div>

      <div v-if="editable" class="col-md-6">
        <div class="form-group">
          <drop-down :title="ddTitleMake">
            <a slot="title" class="dropdown-togGLe" data-togGLe="dropdown">
              <span>{{ddTitleMake}}</span>
              <i class="material-icons">expand_more</i>
            </a>
            <li><a @click="putMake('Queclink');updateModel('queclink')" >Queclink</a></li>
             <li><a @click="putMake('Calamp');updateModel('calamp')" >Calamp</a></li>
          </drop-down>
        </div>
      </div>

      <div v-if="!editable" class="col-md-6">
        <fg-input type="text"
                  label="Modelo"
                  :disabled="!editable"
                  v-model="gps.model">
        </fg-input>
      </div>

      <div v-if="editable" class="col-md-6">
        <div class="form-group">
          <drop-down :title="ddTitleModel">
            <a slot="title" class="dropdown-togGLe" data-togGLe="dropdown">
              <span>{{ddTitleModel}}</span>
              <i class="material-icons">expand_more</i>
            </a>
            <li v-if="ddTitleMake === 'Queclink'"
                v-for="model in queclinkModels" v-bind:key="model.id">
                <a @click="putModel(model)">{{model}}</a></li>
            <li v-if="ddTitleMake === 'Calamp'"
                v-for="model in calampModels" v-bind:key="model.id">
                <a @click="putModel(model)">{{model}}</a></li>
          </drop-down>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editable: null,
    gps: null,
    flex: null
  },
  created () {
    if(this.editable){
      this.ddTitleMake = 'Queclink'
      this.ddTitleModel = this.queclinkModels[0]
      this.gps.make = 'Queclink'
      this.gps.model = this.queclinkModels[0]
    }
    if(!this.editable){
      this.ddTitleMake = this.gps.make
      this.ddTitleModel = this.gps.model
    }
    // para flex
    if (this.flex !== undefined)
      this.flex.tecnology = 'GPS'
  },
  data () {
    return {
      ddTitleTec: 'GPS',
      ddTitleMake: '',
      ddTitleModel: '',
      queclinkModels: ['GL300','GV200','GV300','GL200',
                        'GV500','GV55'],
      calampModels: ['LMU2630','LMU2720','LMU200','LMU300','LMU3030']
    }
  },
  methods: {
    // Para flex
    putTec (newTitle) {
      if (this.flex !== undefined) {
        this.ddTitleTec = newTitle
        this.flex.tecnology = newTitle
      }
    },
    putMake (newTitle) {
      this.ddTitleMake = newTitle
      this.gps.make = newTitle
    },
    putModel (newTitle) {
      this.ddTitleModel = newTitle
      this.gps.model = newTitle
    },
    updateModel(make) {
      if(make === 'queclink')
        this.putModel(this.queclinkModels[0])
      else if (make === 'calamp')
        this.putModel(this.calampModels[0])
    },
    input_changed (key,has_error) {
      this.$emit('input-changed', key, has_error)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// GPSForm.vue?12b2ba9e